export const GST_OFFSET_MS = 4 * 60 * 60 * 1000;

const pad = (n: number) => String(n).padStart(2, "0");

const shifted = (iso: string): Date => new Date(new Date(iso).getTime() + GST_OFFSET_MS);

export const gstDate = (iso: string): string => {
  const d = shifted(iso);
  return `${pad(d.getUTCDate())}.${pad(d.getUTCMonth() + 1)}.${d.getUTCFullYear()}`;
};

export const gstDateTime = (iso: string): string => {
  const d = shifted(iso);
  return `${gstDate(iso)} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
};
